import React from 'react';

const Path1 = ({ className }) => {
  return (
    <svg
        className={className} 
        width="1322" 
        height="756" 
        viewBox="0 0 1322 756" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M2 753.5C158 753.5 290.783 705.024 397 643C876.5 363 892.5 769.266 892.5 561C892.5 450 1084.66 531.5 1052 427C1004.5 275 656 279 397 450C208.71 574.315 272.5 317.35 359 260.5C595.27 105.217 757 135 1098 260.5C1197.83 287.603 1248.37 195.139 1200.5 169C1006.37 63 1080 2.5 1319.5 2.5" 
            stroke="#D4A24C" 
            stroke-width="4" 
            stroke-linecap="round" 
            stroke-dasharray="8 18"
        />
    </svg>
  );
};

export default Path1;
